/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import {withFormikField} from 'src/utils/formik';
import {Box} from '@mui/material';
import TextField from '@mui/material/TextField';
import {format} from 'date-fns';
import {DatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import deLocale from 'date-fns/locale/de';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';

interface ZsDatePickerProps {
    label: string;
    tooltip: string;
    errorText: string;
    dateFormat: string;
    onChange: ({target: {value}} : any) => void;
    value: string;
    required: boolean;
}

const getTimeValue = (date: any, dateFormat: any) => {
    try {
        return dateFormat && date ? format(new Date(date), dateFormat) : date;
    } catch (e) {
        return date || '';
    }
};

export const ZsDatePicker: React.FC<ZsDatePickerProps> = ({
                                                                      label,
                                                                      tooltip,
                                                                      errorText,
                                                                      onChange,
                                                                      value,
                                                                      dateFormat,
                                                                      ...props
                                                                  }) => {

    const getMinDate = () => {
        const d = new Date();
        d.setDate(d.getDate() - 41);
        return d;
    }

    return (
        <Box style={{position: 'relative'}}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={deLocale}>
                <DatePicker
                    label={label}
                    disableFuture
                    minDate={getMinDate()}
                    value={value || null}
                    onChange={(date) =>
                        onChange({
                            target: {
                                value: getTimeValue(date, dateFormat),
                            },
                        })
                    }
                    renderInput={(params) => <TextField {...params} inputProps={{
                        ...params.inputProps,
                        placeholder: "tt.mm.jjjj"
                    }} fullWidth required={props.required} hiddenLabel
                                                        size="small" error={!!errorText} helperText={errorText}/>}
                    {...props}
                />
            </LocalizationProvider>

        </Box>
    );
};

const ZsFormikDatePicker = withFormikField(ZsDatePicker);

export default ZsFormikDatePicker;
